export default __webpack_public_path__ + "static/media/sidian-bank-logo-secondary.a795e1d9.png";